<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex offset-md2 md8 xs12 px-2>
        <v-card>
          <v-toolbar flat dense color="primary" dark>
            <v-toolbar-title>
              {{ $t('titles.global.followings') }}
            </v-toolbar-title>
            <v-spacer />
            <v-btn v-if="id" icon dark :loading="loading" @click="init">
              <v-icon>refresh</v-icon>
            </v-btn>
            <!-- <v-btn flat @click="dialog = true">{{$t('action.buttons.new')}}</v-btn> -->
          </v-toolbar>
          <v-toolbar card flat dense color="white">
            <v-text-field
              v-model="match"
              flat
              hide-details
              :placeholder="$t('action.buttons.search')"
              prepend-icon="search"
              solo
            />
          </v-toolbar>
          <v-divider />
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="userFollowings"
              disable-initial-sort
              :search="match"
              :loading="loading"
              :rows-per-page-items="[8]"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.type }}</td>
                <td>
                  <v-chip small color="transparent">
                    <v-avatar v-if="props.item.img" size="32">
                      <img :src="props.item.img" alt />
                    </v-avatar>

                    <v-list-tile-content>
                      <v-list-tile-title class="body-1">
                        {{ props.item.name }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        v-if="props.item.categoryName"
                        class="caption grey--text text--lighten-1 text-truncate"
                      >
                        {{ props.item.categoryName.join(', ') }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-chip>
                </td>
                <td class="text-xs-center">
                  <button-state :state="!!props.item.notifications" />
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TabFollowings',
  props: {
    id: { type: String, required: false, default: '' },
  },
  data() {
    return {
      match: '',
      dialog: false,
      loading: false,
    }
  },
  // created() {
  //   this.init()
  // },
  computed: {
    ...mapGetters({
      userFollowings: 'users/userFollowings',
    }),
    headers() {
      let headers = [
        {
          text: this.$t('fields.global.type'),
          value: 'type',
        },
        {
          text: this.$t('fields.global.name'),
          value: 'name',
        },

        {
          text: this.$tc('models.notification', 2),
          value: 'notifications',
          align: 'center',
        },
      ]

      return headers
    },
  },
  methods: {
    ...mapActions({
      fetchUserFollowings: 'users/fetchUserFollowings',
    }),
    init() {
      if (this.id) {
        this.loading = true
        this.fetchUserFollowings(this.id).finally(() => {
          this.loading = false
        })
      }
    },
  },
}
</script>
